var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup27(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 53C11.8967 53 0 41.1032 0 26.5C0 11.8967 11.8967 0 26.5 0C41.1032 0 53 11.8967 53 26.5C53 41.1032 41.1032 53 26.5 53ZM26.5 1.51682C12.7295 1.51682 1.48709 12.7295 1.48709 26.5297C1.48709 40.33 12.6998 51.5426 26.5 51.5426C40.3002 51.5426 51.5129 40.33 51.5129 26.5297C51.5129 12.7295 40.3002 1.51682 26.5 1.51682Z",
    fill: "#209BB7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26 40C18.847 40 13 33.9589 13 26.5C13 19.0411 18.8173 13 26 13C33.1826 13 39 19.0411 39 26.5C39 33.9589 33.1826 40 26 40ZM26 14.5719C19.6484 14.5719 14.484 19.9349 14.484 26.5308C14.484 33.1267 19.6484 38.4897 26 38.4897C32.3516 38.4897 37.516 33.1267 37.516 26.5308C37.516 19.9349 32.3516 14.5719 26 14.5719Z",
    fill: "#209BB7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5185 15L20 1.30237L21.4518 1L24 14.6976L22.5185 15Z",
    fill: "#209BB7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7883 23L1 21.3158L1.21166 20L15 21.6842L14.7883 23Z",
    fill: "#209BB7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup27);
export default __webpack_public_path__ + "static/media/Group27.785bd691553de9fc0ed3a8f9774fa105.svg";
export { ForwardRef as ReactComponent };